import styled from 'styled-components';

export const Container = styled.div`
    width: 80vw;
    height: 92vh;
`;

export const IconArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const SettingArea = styled.div`
    background-color: #1e1e1e;
    color: #fff;
    padding: 0 2rem 2rem 2rem;
    border-radius: 1rem;
    font-family: 'Segoe UI', sans-serif;
`;

export const Header = styled.div`
    background: #2c2c2e;
    padding: 2rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 2rem;
    height: 70vh;
    overflow-y: auto;
`;

export const EditableRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    align-items: center;

    label {
        flex: 1;
        font-size: 1.1rem;
        font-weight: 500;
    }

    input {
        flex: 2;
        padding: 0.6rem 1rem;
        border-radius: 0.5rem;
        border: none;
        font-size: 1rem;
        background: #444;
        color: white;

        &:disabled {
            background: #333;
            color: #aaa;
        }
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
`;

export const Button = styled.button<{$cancel?: boolean}>`
    padding: 0.7rem 1.2rem;
    border-radius: 0.5rem;
    border: none;
    font-weight: bold;
    background: ${({$cancel}) => ($cancel ? '#555' : '#4caf50')};
    color: white;
    cursor: pointer;

    &:hover {
        background: ${({$cancel}) => ($cancel ? '#777' : '#45a049')};
    }
`;

export const InfoRow = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 1.2rem;
`;

export const Partition = styled.hr`
    border: 1px #0099cc solid;
`;

export const DeviceSelector = styled.div`
    margin-bottom: 1.5rem;

    label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 500;
    }

    select {
        width: 100%;
        padding: 0.6rem;
        border-radius: 0.4rem;
        background: #333;
        color: white;
        border: 1px solid #555;
    }
`;

export const VolumeControl = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0 0 1.5rem 0;
`;

export const VolumeSlider = styled.input`
    width: 100%;
    height: 5px;
    border-radius: 5px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
        opacity: 1;
    }

    &::-webkit-slider-thumb {
        appearance: none;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #4caf50;
        cursor: pointer;
    }
`;

export const VolumeLabel = styled.label`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;
`;
